module.exports = __webpack_public_path__ + "img/S1051431.4f8866da.jpg";